import * as React from "react";
import PropTypes from "prop-types";
import { NumericFormat } from "react-number-format";

const FormattedNumberInput = React.forwardRef(function NumericFormatCustom(props, ref) {
    const { onChange, unit, ...other } = props;

    const currencyUnits = ["€", "$", "£", "¥"];
    const isCurrencyField = currencyUnits.includes(props.unit);

    const prefix = isCurrencyField ? unit + " " : "";
    const suffix = isCurrencyField ? "" : " " + unit;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            valueIsNumericString
            decimalScale={isCurrencyField ? 2 : 10}
            prefix={prefix}
            suffix={suffix}
            decimalSeparator=","
            thousandSeparator="."
            allowNegative={props.allowNegative}
        />
    );
});

FormattedNumberInput.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    allowNegative: PropTypes.bool.isRequired,
};

export default FormattedNumberInput;
